var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 44,
    viewBox: "0 0 34 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50182 24.7488C1.55007 18.7182 2.57156 9.08705 6.20836 2.82593C6.2731 2.71448 6.38126 2.63788 6.50824 2.6157C7.80215 2.38972 11.2517 2 16.294 2C21.0812 2 24.9138 2.6048 26.6616 2.99897C26.9316 3.05986 27.0722 3.35117 26.9625 3.60529L22.6486 13.5969C26.618 13.7437 29.2926 14.1369 32.1148 15.0118C32.3604 15.088 32.491 15.3534 32.3923 15.5909C30.2254 20.8074 21.5743 32.2669 8.09079 42C8.09079 35.7439 9.19182 31.4383 11.1212 25.2H1.95316C1.70289 25.2 1.49982 24.999 1.50182 24.7488Z",
    fill: "#FCFF74",
    stroke: "#040A1E",
    strokeWidth: 2.19149,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.0d0b7eb0a198f98a597151ae0cd07724.svg";
export { ForwardRef as ReactComponent };